import { HistoryItem } from "../types/history";

const LS_KEY = "interactionHistory";

export const loadHistory = (): HistoryItem[] => {
    try {
        const raw = localStorage.getItem(LS_KEY);
        if (!raw) return [];
        const data = JSON.parse(raw);

        // Backward-compat: nếu dữ liệu cũ là string[]
        if (Array.isArray(data) && typeof data[0] === "string") {
            return (data as string[]).map((s, i) => ({
                id: `legacy-${i}`,
                kind: "text",
                label: s,
                time:formatDateTime()
            }));
        }
        return data as HistoryItem[];
    } catch {
        return [];
    }
};

export const saveHistory = (arr: HistoryItem[]) =>
    localStorage.setItem(LS_KEY, JSON.stringify(arr));

export const appendHistoryText = (
    setHistory: React.Dispatch<React.SetStateAction<HistoryItem[]>>,
    text: string
) => {
    setHistory(prev => {
        const next: HistoryItem[] = [
            ...prev,
            {
                id: newId(),
                kind: "text",
                label: text,
                time:formatDateTime()
            },
        ];
        saveHistory(next);
        return next;
    });
};

export const appendGuardianMessageItem = (
    setHistory: React.Dispatch<React.SetStateAction<HistoryItem[]>>,
    nodeId: number,
    message: string
) => {
    setHistory(prev => {
        const next: HistoryItem[] = [
            ...prev,
            {
                id: newId(),
                kind: "link",
                label: "Guardian message",   // 👈 thay vì "Guardian message"
                detail: message,
                nodeId,
                time:formatDateTime()
            },
        ];
        saveHistory(next);
        return next;
    });
};

export const appendUserOptionItem = (
    setHistory: React.Dispatch<React.SetStateAction<HistoryItem[]>>,
    nodeId: number,
    optionId: number,
    optionText: string
) => {
    setHistory(prev => {
        const next: HistoryItem[] = [
            ...prev,
            {
                id: newId(),
                kind: "text",
                label: optionText,   // 👈 thay vì "User choice"
                nodeId,
                optionId,
                time:formatDateTime()
            },
        ];
        saveHistory(next);
        return next;
    });
};

export const getRandomNumber = (min: number, max: number): number =>
    Math.floor(Math.random() * (max - min + 1)) + min;

export const formatDateTime = (): string => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const MM = String(now.getMonth() + 1).padStart(2, "0");
  const yyyy = now.getFullYear();
  const HH = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  return `${dd}/${MM}/${yyyy} ${HH}:${mm}:${ss}`;
};
export function newId() {
    if (crypto && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    // fallback cho server/browser cũ
    return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const buildInteractionLogJson = (downloadContent: string, endActionLabel: string) => {
    return JSON.stringify(
        downloadContent
    );
};
